import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy URL — supplier details now live under the list at /suppliers/list/details/$id.
export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/details/$id/')({
    params: {
        parse({ id }) {
            return {
                id: BigInt(id),
            };
        },
    },
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id',
            params,
            replace: true,
        });
    },
});
